/* Highlight specific top-level header link (Sale) in header navigation */
(function () {
  var targets = [
    location.origin + '/collections/sale',
    location.origin + '/collections/sale/',
    '/collections/sale',
    '/collections/sale/',
  ];

  function normalizeHref(href) {
    if (!href) return '';
    try { return new URL(href, location.origin).href; } catch (e) { return href; }
  }

  function markSaleLink() {
    var nodes = document.querySelectorAll(
      '.header__links-primary .header__links-list a, .header__links-primary .header__links-list [data-link], .drawer-menu__link'
    );
    nodes.forEach(function (el) {
      var raw = el.getAttribute('href') || el.dataset.href || el.href || '';
      var full = normalizeHref(raw);
      if (targets.indexOf(full) !== -1 || targets.indexOf(raw) !== -1) {
        el.classList.add('force-featured-link-js');
        // Also add theme's featured-link class so existing CSS rules apply
        el.classList.add('featured-link');
        // Style the element and the inner .link-hover if present
        try { el.style.setProperty('color', '#A70100', 'important'); } catch (e) { el.style.color = '#A70100'; }
        var lh = el.querySelector && (el.querySelector('.link-hover') || el.querySelector('.drawer-menu__link-title span'));
        if (lh) {
          try { lh.style.setProperty('color', '#A70100', 'important'); } catch (e) { lh.style.color = '#A70100'; }
        }
      }
    });
  }

  function init() {
    markSaleLink();
    // Observe the whole document to catch mobile drawer updates
    var container = document.documentElement || document.body;
    var mo = new MutationObserver(function () { markSaleLink(); });
    mo.observe(container, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else init();
})();
